module.exports = __webpack_public_path__ + "next.png?31f15875975aab69085470aabbfec802";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next.png
// module id = 317
// module chunks = 0